import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';

console.log("Script is running");
console.log("version 1.0.1");

const renderApp = () => {
  console.log("Attempting to render app");
  let attempts = 0;
  const maxAttempts = 10;

  const tryRender = () => {
    const rootElement = document.getElementById('react-target');
    if (rootElement) {
      console.log("React target element found");
      const root = ReactDOM.createRoot(rootElement);
      root.render(
        <React.StrictMode>
          <HashRouter>
            <App />
          </HashRouter>
        </React.StrictMode>
      );
    } else {
      console.log(`React target element not found, attempt ${attempts + 1} of ${maxAttempts}`);
      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(tryRender, 100);
      } else {
        console.error("Failed to find react-target element after multiple attempts");
      }
    }
  };

  tryRender();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  renderApp();
}
